import { Box, Button, Paper, Typography, styled, Table, TableContainer } from '@mui/material';

export const UploadContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  backgroundColor: '#FFFFFF',
  borderRadius: '4px',
  boxShadow: 'none',
}));

export const UploadTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '32px',
  marginBottom: theme.spacing(3),
  color: '#333333',
  alignSelf: 'flex-start',
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#00B6BA',
  color: '#FFFFFF',
  borderRadius: '4px',
  fontWeight: 600,
  padding: '8px 16px',
  minWidth: 'fit-content',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#009B9F',
  },
  '&:disabled': {
    backgroundColor: '#E0E0E0',
    color: '#9E9E9E',
    opacity: 0.7,
    cursor: 'not-allowed',
    boxShadow: 'none',
    pointerEvents: 'auto',
    '&:hover': {
      backgroundColor: '#E0E0E0',
    }
  },
}));

export const ChooseFileButton = styled(Button)(({ theme }) => ({
  borderColor: '#00B6BA',
  color: '#00B6BA',
  padding: '8px 16px',
  minWidth: 'fit-content',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    borderColor: '#009B9F',
    backgroundColor: 'rgba(0, 182, 186, 0.04)',
  },
  '&:disabled': {
    borderColor: '#E0E0E0',
    color: '#9E9E9E',
  },
}));

export const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: 'margin-left 0.3s ease',
  backgroundColor: '#E7EFF5',
  minHeight: 'calc(100vh - 72px)',
  height: '100%',
}));

export const ErrorTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: theme.spacing(3),
  width: '100%',
  border: '1px solid rgba(224, 224, 224, 1)',
  borderRadius: '4px',
  maxHeight: '400px',
  overflowY: 'auto',
  backgroundColor: '#fff',
}));

export const ErrorSummary = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '16px',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),
  color: '#d32f2f',
  '& .file-name': {
    fontStyle: 'italic',
    fontWeight: 400,
    paddingLeft: theme.spacing(0.5),
  }
}));

export const ErrorCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: '#d32f2f',
}));

export const ErrorHeader = styled(Box)(({ theme }) => ({
  backgroundColor: '#f5f5f5',
  padding: theme.spacing(1.5),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

export const ErrorCount = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#d32f2f',
  color: '#fff',
  borderRadius: '50%',
  width: '24px',
  height: '24px',
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  fontSize: '14px',
})); 